export default __webpack_public_path__ + "more_horiz.a5fbf678.svg";